import type { ReactNode } from "react";

import { getBaseUrl } from "~/shared/utils/get-base-url.ts";

import * as styles from "./public-layout.module.css";

const baseUrl = getBaseUrl();

type PublicLayoutProps = {
	readonly children: ReactNode;
};

export function PublicLayout({ children }: PublicLayoutProps) {
	return (
		<div className={styles.wrapper}>
			<aside className={styles.sidebar}>
				<img
					alt={"Cincinnati skyline"}
					src={`${baseUrl}/images/cinicinnati-sidebar.png`}
				/>
			</aside>
			<div className={styles.content}>{children}</div>
		</div>
	);
}
